import L from 'leaflet';

const SHADOW_URL = 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png';

export type MarkerColor = 'green' | 'red' | 'gray' | 'default';

export function createColoredIcon(color: MarkerColor): L.Icon {
  if (color === 'default') {
    return new L.Icon.Default() as unknown as L.Icon;
  }

  const hue = color === 'green' ? '130' : color === 'red' ? '0' : '0';
  const sat = color === 'gray' ? '0%' : '70%';
  const light = color === 'gray' ? '60%' : color === 'red' ? '45%' : '35%';
  const fill = `hsl(${hue}, ${sat}, ${light})`;
  const stroke =
    color === 'gray'
      ? 'hsl(0,0%,40%)'
      : color === 'red'
        ? 'hsl(0,70%,30%)'
        : 'hsl(130,70%,20%)';

  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="41" viewBox="0 0 25 41">
    <path d="M12.5 0C5.6 0 0 5.6 0 12.5C0 21.9 12.5 41 12.5 41S25 21.9 25 12.5C25 5.6 19.4 0 12.5 0z" fill="${fill}" stroke="${stroke}" stroke-width="1"/>
    <circle cx="12.5" cy="12.5" r="5" fill="white" opacity="0.9"/>
  </svg>`;

  return L.icon({
    iconUrl: `data:image/svg+xml;base64,${btoa(svg)}`,
    shadowUrl: SHADOW_URL,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });
}
